import { Spinner } from '@chakra-ui/react';
import React from 'react';

import { DownloadAllLiveFundingNoticesButton } from 'packages/funding-requests/ui/submit/DownloadAllLiveFundingNoticesButton';
import { useGetLoanRecordByFundingRequestAndCommitmentKeyQuery } from 'packages/loans/requests/loans.gql.generated';

type DownloadAllLiveFundingNoticesFromFundingRequestButtonProps = {
  fundingRequestId: string;
  commitmentKey: string;
};

export const DownloadAllLiveFundingNoticesFromFundingRequestButton = ({
  fundingRequestId,
  commitmentKey,
}: DownloadAllLiveFundingNoticesFromFundingRequestButtonProps) => {
  const {
    data: loansData,
    loading: isLoansDataLoading,
  } = useGetLoanRecordByFundingRequestAndCommitmentKeyQuery({
    fetchPolicy: 'network-only',
    variables: { fundingRequestId, commitmentKey },
  });

  if (isLoansDataLoading || !loansData) {
    return <Spinner />;
  }

  // expect exactly one loan per funding request
  if (!loansData.loan) {
    return null;
  }

  return (
    <DownloadAllLiveFundingNoticesButton
      loanId={loansData.loan.id}
      creditFacilityId={loansData.loan.creditFacilityId}
      fundingRequestId={fundingRequestId}
    />
  );
};
